import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Preset } from '../types';

interface PresetChipsProps {
  presets: Preset[];
  selectedPreset: string | null;
  onPresetClick: (preset: Preset) => void;
}

export function PresetChips({
  presets,
  selectedPreset,
  onPresetClick,
}: PresetChipsProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: 'action.hover',
        ...(isMobile && { borderBottom: 1, borderColor: 'divider' }),
      }}
    >
      <Typography variant="overline" sx={{ color: 'text.secondary', mb: 3 }}>
        Quick ranges
      </Typography>
      <Stack
        direction={isMobile ? 'row' : 'column'}
        spacing={1}
        sx={{
          ...(isMobile && {
            flexWrap: 'wrap',
            '& > *': { minWidth: 'fit-content' },
          }),
        }}
      >
        {presets.map((p) => {
          const selected = selectedPreset === p.id;
          return (
            <Chip
              key={p.id}
              label={p.label}
              variant={selected ? 'filled' : 'outlined'}
              color={selected ? 'primary' : 'default'}
              onClick={() => onPresetClick(p)}
              size={'medium'}
            />
          );
        })}
      </Stack>
    </Box>
  );
}
